'use client';
import React from 'react';

interface SectionContainerProps {
  title?: string | React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  childrenFullWidth?: boolean;
  contentClassName?: string;
  titleClassName?: string;
  titleStyle?: React.CSSProperties;
}

export const SectionContainer: React.FC<SectionContainerProps> = ({
  title,
  children,
  className = '',
  titleClassName = '',
  contentClassName = '',
  childrenFullWidth = false,
  titleStyle,
}) => {
  return (
    <div className={`w-full mb-[200px] mobile:mb-20 last:mb-0 ${className}`}>
      {title && (
        <h2
          style={titleStyle}
          className={`max-w-[1372px] mx-auto break-words hyphens-auto text-[56px] leading-[1.5] font-400 text-[#121C59] mb-10 mobile:text-[24px] mobile:mb-6 mobile:!max-w-full mobile:px-5 ${titleClassName}`}
        >
          {title}
        </h2>
      )}
      <div
        className={`${
          !childrenFullWidth
            ? 'max-w-[1372px] mx-auto mobile:!max-w-full mobile:px-5'
            : ''
        } ${contentClassName}`}
      >
        {children}
      </div>
    </div>
  );
};
